import React from 'react';
import {connect} from 'react-redux';
// import {Link} from 'react-router';
import {Button, EmailInput} from '../Presentation/Forms';
import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import Loader from '../Presentation/Loader';

import {forgottenPasswordAction} from '../../actions/Auth';
import {openSuccessPopup, openFailPopup} from '../../actions/Popup';

class ForgottenPassword extends React.Component {

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    submit(e) {
        e.preventDefault();
        if (this.refs.email.validate()) {
            this.dispatchForgottenPassword();
        }
        return false;
    }

    dispatchForgottenPassword() {
        this.props.dispatch(forgottenPasswordAction(
            this.dispatchForgottenPassword,
            { email: this.refs.email.getValue() }
        ))
            .then(() => {
                this.props.dispatch(openSuccessPopup({
                    title: "Проверете пощата си",
                    text: "Изпратихме ви имейл с линк за потвърждение"
                }));
            })
            .catch(() => {
                this.props.dispatch(openFailPopup({
                    title: "Грешка",
                    text: "Възникна грешка"
                }));
            });
    }

    getInputValues() {
        return {
            email: this.refs.email ? this.refs.email.getValue() : ""
        }
    }

    render() {
        const {email} = this.getInputValues();
        const {pending} = this.props;

        return <FullWidthPage title="Забравена парола">
            <form className="profile-form login">
                <div className="row">
                    <div className="col-md-6 col-md-offset-3">
                        <SectionTitle>Забравена парола?</SectionTitle>
                        <Loader show={pending}/>
                        <div className={pending ? "loading" : ""}>
                            <EmailInput ref="email" value={email} id="email" name="email"
                                        required="required" label="Е-мейл Адрес"/>
                            {/*<div className="text-right">*/}
                                {/*<Link className="login-link" to="/register">Вход</Link> | <Link className="login-link" to="/register">Регистрация</Link>*/}
                            {/*</div>*/}

                            <div className="text-center">
                                <Button clickHandler={this.submit} text="Изпрати"/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {
        pending: state.auth.forgottenPasswordPending,
        credentialsError: state.auth.loginError
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ForgottenPassword);


// WEBPACK FOOTER //
// ./src/components/Pages/ForgottenPassword.js